import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { getAuth } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../Configuration/firebase";
import {
  fetchJoinableEvent,
  joinEvent,
  recordJoinedEvent,
} from "../utils/events";
import { registerPush } from "../utils/push";

// Landing point for a tapped event link (iblink.app/e/CODE) inside the app -
// reached both when the OS opens the app via a Universal Link / App Link (see
// the appUrlOpen handler in App.js) and if a signed-in user hits /e/CODE. It
// joins the event (unless you're the host) and forwards to the event screen.
const EventDeepLink = () => {
  const { code } = useParams();
  const navigate = useNavigate();
  const [error, setError] = useState("");

  useEffect(() => {
    let cancelled = false;
    (async () => {
      const user = getAuth().currentUser;
      if (!user) {
        navigate("/login", { replace: true });
        return;
      }
      try {
        const event = await fetchJoinableEvent(code);
        // Hosts don't join their own event; everyone else joins on open.
        if (event.hostUid !== user.uid) {
          const snap = await getDoc(doc(db, "users", user.uid));
          const info = snap.exists() ? snap.data() : {};
          const name =
            [info.firstName, info.lastName].filter(Boolean).join(" ").trim() ||
            info.email ||
            "Guest";
          await joinEvent({ code: event.code, user, name });
          recordJoinedEvent(user.uid, event.code);
          registerPush(user.uid);
        }
        if (!cancelled) navigate(`/event/${event.code}`, { replace: true });
      } catch (err) {
        console.error("Deep link join failed:", err);
        if (!cancelled) {
          setError(err.message || "Couldn't open that event.");
        }
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [code, navigate]);

  return (
    <div className="container" style={{ padding: "24px", textAlign: "center" }}>
      {error ? (
        <>
          <p>{error}</p>
          <button
            type="button"
            onClick={() => navigate("/join-event", { replace: true })}
            style={{
              backgroundColor: "#4CAF50",
              color: "white",
              padding: "10px 20px",
              border: "none",
              borderRadius: "6px",
              cursor: "pointer",
            }}
          >
            Enter a code instead
          </button>
        </>
      ) : (
        <p>Opening event…</p>
      )}
    </div>
  );
};

export default EventDeepLink;
